module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_07_american-village-2b5ba64b83d2a1a30da4fadead5fe4c4.jpg";